module.exports = __webpack_public_path__ + "static/icons/icon-sandbar--red-5e263b2012d6b308db5ecd219178058e.svg";